import React, { Fragment } from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import MiscList from "./../shared/misc-list.jsx";
import MiscGrid from "./../shared/misc-grid.jsx";
import TCSummary from "./../shared/tc-summary.jsx";
import ReasonList from "./../shared/reason-list.jsx";
import immutable from "immutable";
import TCClockEditItemGrid from "./tc-clock-edit-item-grid.jsx";
import { browserHistory } from "react-router";

export default class TCClockEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecardData: {
                weekDays: [],
                inReasons: [],
                outReasons: [],
                timecard: null,
                timecardLineDatas: [],
                logWorkDialog: false,
                placementTasks: [],
                disableMealBreakRounding: false,
                enableCopyWorkHours: false,
                preloadHolidayHours: false
            },
            misc: {
                weekDays: [],
                reasons: [],
                expenses: [],
                isPtoEnabled: false
            },
            
        };

        this.onAddMisc = this.onAddMisc.bind(this);
        this.onDeleteMiscItem = this.onDeleteMiscItem.bind(this);
        this.onUpdateMiscItem = this.onUpdateMiscItem.bind(this);
        this.onDeleteTcLineDetail = this.onDeleteTcLineDetail.bind(this);

        this.onLogWork = this.onLogWork.bind(this);
        this.loadTimecard = this.loadTimecard.bind(this);
        this.isIncomplete = this.isIncomplete.bind(this);
    }

    onAddMisc(misc) {
        // const clone = immutable.fromJS(this.state).toJS();
        // let index = -1;
        // for (let i = 0; i < clone.misc.expenses.length; i++) {
        //     if (clone.misc.expenses[i].expenseId == misc.expenseId) {
        //         index = i;
        //         break;
        //     }
        // }
        // if (index > -1) {
        //     clone.misc.expenses[index] = misc;
        // } else {
        //     clone.misc.expenses.push(misc)
        // }
        // clone.misc.expenses.sort((a, b) => a.expenseDate < b.expenseDate ? -1 : a.expenseDate > b.expenseDate ? 1 : 0);
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    onDeleteTcLineDetail(response) {
        // const clone = immutable.fromJS(this.state).toJS();
        // for (let i = 0; i < clone.timecardData.timecardLineDatas.length; i++) {
        //     let idx = -1;
        //     let tcLine = clone.timecardData.timecardLineDatas[i];

        //     if (tcLine.timecardLine.timecardLineId === response.deletedTcLineId) {
        //         clone.timecardData.timecardLineDatas.splice(i, 1);
        //         break;
        //     } else {
        //         for (let j = 0; j < tcLine.timecardLineDetails.length; j++) {
        //             if (tcLine.timecardLineDetails[j].timecardDetailLineId === response.deletedTcLineDetailId) {
        //                 idx = j;
        //                 break;
        //             }
        //         }

        //         if (idx > -1) {
        //             tcLine.timecardLineDetails.splice(idx, 1);
        //             break;
        //         }
        //     }
        // }

        // this.setState(clone);
        this.loadTimecard(this.state.timecardId);
        this.loadReasonList();
    }

    onDeleteMiscItem(expenseId) {
        // const clone = immutable.fromJS(this.state).toJS();
        // let removed = null;
        // for (let i = 0; i < clone.misc.expenses.length; i++) {
        //     if (clone.misc.expenses[i].expenseId == expenseId) {
        //         removed = i;
        //         break;
        //     }
        // }
        // if (removed > -1) clone.misc.expenses.splice(removed, 1);
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    onUpdateMiscItem(expenseId, misc) {
        // const clone = immutable.fromJS(this.state).toJS();
        // let removed = expenseId != misc.expenseId ? expenseId : null;
        // let index = -1;

        // for (let i = 0; i < clone.misc.expenses.length; i++) {
        //     if (clone.misc.expenses[i].expenseId == expenseId) {
        //         index = i;
        //         break;
        //     }
        // }
        // if (index > -1) clone.misc.expenses[index] = misc;                
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        if (this.props.timecardId) {
            this.loadTimecard(this.props.timecardId);
        }
    }

    onLogWork(res) {
        if (res.data.timecardId != this.props.timecardId) {
            this.props.onNewTimecardAdded(res.data.timecardId);
        }
        else {
            this.loadTimecard(res.data.timecardId);
            this.loadReasonList();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.timecardId && nextProps.timecardId !== this.props.timecardId) {
            this.loadTimecard(nextProps.timecardId);
        }
    }


    loadTimecard(timecardId) {
        let self = this;
        context.message({
            type: "loading",
            message: "Loading. Please wait...",
            show: true,
        });
        ajax.vm()
            .get(`people/tc-clock-edit-form/${timecardId}`)
            .then(function (res) {
                self.setState(res.data);
                let errors = [];
                let timecard = null;
                let timecardData = res.data.timecardData;
                if (timecardData) {
                    timecard = timecardData.timecard;

                    if (timecard) {                        
                        if (timecard.timecardType == 'DURATIONTC' &&
                            self.props.durationTcRoute && self.props.durationTcRoute.trim().length > 0) {                        
                            //browserHistory.push(self.props.durationTcRoute.replace(":timecardId", timecard.timecardId));
                            var url = context.routeUrl(self.props.durationTcRoute.replace(":timecardId", timecard.timecardId));
                            window.location = url;
                        }
                    
                        timecard.jobTitle = res.data.jobTitle; // adding this field so we can pass it to parent component
                    } else {

                        ajax.api()
                            .get(`people/tc-type`)
                            .then(function (res) {
                                const result = res.data;
                                if (result == "DURATIONTC") {
                                    var url = context.routeUrl(self.props.durationTcRoute.replace(":timecardId", ""));
                                    window.location = url;
                                }
                            });                        
                    }

                    if (timecardData.placementTasks == null || timecardData.placementTasks.length == 0)
                        errors = ["Placement tasks are missing. Please contact Help Desk"];
                }

                if (self.props.onLoadTimecardCompleted)
                    self.props.onLoadTimecardCompleted(timecard, errors);

                self.refs.tcSummary.clearNotes();

                context.message({
                    show: false,
                });
            });
    }

    loadReasonList() {
        // since this.state.timecardId is not changing, ReasonList component won't automatically re-render
        this.refs.reasonList.reloadReason(this.state.timecardId);
    }

    isIncomplete() {
        return this.state.timecardData.isIncomplete;
    }

    render() {
        let vm = this.state;
        let self = this;
        const openRole = self.props.role;
        const isPayrollAdmin = (openRole === "payroll-admin");
        const tcGrid = this.props.hideGrid ? null :
            (<TCClockEditItemGrid vm={vm.timecardData} onDeleteTcLineDetail={this.onDeleteTcLineDetail} onLogWork={this.onLogWork}
                allowEdit={this.props.allowEdit} role={openRole} showAltered={this.props.showAltered} />);
        const requireNotes = this.props.requireNotes ? true : false;
        const tcStatus = vm.timecardData.timecard ? vm.timecardData.timecard.statusCode : "";
        return (
            <div>
                {tcGrid}
                {
                isPayrollAdmin ? 
                    <Fragment>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12"><hr /></div>
                            </div>
                        </div>
                        <MiscList vm={vm.misc} onDeleteMiscItem={this.onDeleteMiscItem} timecardId={vm.timecardId} timecardStatus={tcStatus}
                            onAddMisc={this.onAddMisc} onUpdateMiscItem={this.onUpdateMiscItem} onNewTimecardAdded={this.props.onNewTimecardAdded}
                            onDeleteTcLineDetail={this.onDeleteTcLineDetail} allowEdit={this.props.allowEdit} weekEnding={this.props.weekEnding}
                            role={openRole} ref="miscList" />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12"><hr /></div>
                            </div>
                        </div>
                    </Fragment>
                    :
                    <MiscGrid vm={vm.misc} onDeleteMisc={this.onDeleteMiscItem} timecardId={vm.timecardId}
                        onAddMisc={this.onAddMisc} onUpdateMisc={this.onUpdateMiscItem} onNewTimecardAdded={this.props.onNewTimecardAdded}
                        allowEdit={this.props.allowEdit} weekEnding={this.props.weekEnding} preloadHolidayHours={vm.timecardData.preloadHolidayHours}
                        role={openRole} ref="miscList" hideTotalHours={true} hideTotalHoursDaily={true} />
                }
                <TCSummary vm={vm} ref="tcSummary" requireNotes={requireNotes} showTotalHoursDaily={!isPayrollAdmin} />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12"><hr /></div>
                    </div>
                </div>
                <ReasonList timecardId={vm.timecardId} ref="reasonList" />
            </div>
        );
    }
}